import React, {useState, useEffect, useCallback} from 'react'
import {useDispatch} from 'react-redux'
// BASE Components
import BASELoading from "../../../../../../../@BASE/core/BASELoading";
import BASESvgIcon from '../../../../../../../@BASE/core/BASESvgIcon';
// Material UI
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from '@mui/material/Paper';
// Custom Components
import { ImageAttribution } from '../components/ImageAttribution';
import EMentor from "../components/EMentor";
import JobAideStatement from '../components/JobAideStatement';
import Instructions from "../components/Instructions";
import ComponentCard from "../components/Component";
import ComponentPreview from "../components/Preview";
import ComponentStepLabel from "../components/StepLabel";
import SubComponentCard from "../components/SubComponent";
import SummaryInstructions from '../components/SummaryInstructions';

import { getInstance } from "../../../../../../actions";

export default function FPECapstone(props) {
  const { data, dir, ins = [], course, comments = [] } = props
  const tl = dir === 'rtl' ? 'text-18' : 'text-14';

  const dispatch = useDispatch();
  const [isFetched, setIsFetched] = useState(false);
  const [completionPages, setCompletionPages] = useState([]);

  if (!data) {
    return <BASELoading />;
  }

  const getCompletionPage = useCallback(
    async (page_id) => {
      try {
        const response = await dispatch(getInstance("pages")(page_id)).unwrap();
        return response;
      } catch (error) {
        console.error("Failed to fetch lesson pages:", error);
        return null;
      }
    },
    [dispatch] // Memoizing the function to prevent re-creation
  );

  useEffect(() => {
    if (!data.core.fpe || isFetched) return; // Prevent re-fetching
  
    setIsFetched(true); // Mark as fetched
  
    const fetchPages = async () => {
      const pages = await Promise.all(
        data.notebook.map((feedback) => getCompletionPage(feedback.interaction_id))
      );
  
      setCompletionPages(pages);
    };
  
    fetchPages();
  }, [data.core.fpe, data.notebook, getCompletionPage]);

  // filer comments by component_id
  const componentCommentsCount = (component_id) => { return comments.filter((comment) => comment.component_id === component_id).length; };

  return (
    <div>
      <style>
        {`
          .wysiwyg p {
            margin: 0px;
          }
        `}
      </style>

      <Instructions ins={ins.filter(data => data.label.includes("default"))} course={course} dir={dir} tl={tl} componentCommentsCount={componentCommentsCount} noInstructions />
      
      <ComponentCard title="Section 1" id={data.section.id} commentsCount={componentCommentsCount(data.section.id)}>
        {/* <ComponentPreview>
          <ObjectiveItem objective={objective} index={index} diagram />
        </ComponentPreview> */}
        <SubComponentCard
          title="Prompt"
          id={data.section.id + "_prompt"}
          commentsCount={componentCommentsCount(data.section.id + "_prompt")}
        >
          <Paper
            elevation={0}
            square
            className="p-16"
          >
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    <Typography 
                      className={`${tl} m-0`}
                      dir={dir}
                      dangerouslySetInnerHTML={{ __html: data.section.prompt }} 
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </SubComponentCard>

        <SubComponentCard
          title="Lures"
          id={data.section.id + "_lures"}
          commentsCount={componentCommentsCount(data.section.id + "_lures")}
        >
          <Paper
            elevation={0}
            square
            className="p-16"
          >
            <Grid container spacing={0}>
              {data.section.lures.map((lure, index) => (
                <Grid
                  key={`lure-${lure.lure_text}-${index}`}
                  item
                  xs={12}
                >
                  {index > 0 && <Divider className="mt-2 mb-8" />}
                  <Grid container spacing={0} columns={24}>
                    <Grid item xs={4}>
                      {lure.is_correct ? (
                        <Grid container direction="row">
                          <Typography className="text-14 font-semibold m-0">
                            Correct
                          </Typography>
                          <BASESvgIcon
                            className="text-green-600 mx-2"
                            size={20}
                          >
                            heroicons-solid:check-circle
                          </BASESvgIcon>
                          <Typography className="text-14 font-semibold m-0">
                            Lure:
                          </Typography>
                        </Grid>
                      ) : (
                        <Grid container direction="row">
                          <Typography className="text-14 font-semibold m-0">
                            Incorrect
                          </Typography>
                          <BASESvgIcon
                            className="text-red-600 mx-2"
                            size={20}
                          >
                            heroicons-solid:x-circle
                          </BASESvgIcon>
                          <Typography className="text-14 font-semibold m-0">
                            Lure:
                          </Typography>
                        </Grid>
                      )}
                    </Grid>
                    <Grid item xs>
                      <Typography
                        className={`${tl} m-0 ${
                          index < data.section.lures.length - 1 && `mb-8`
                        }`}
                        dir={dir}
                      >
                        {lure.lure_text}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </Paper>

        </SubComponentCard>
        

        
      </ComponentCard>

      <ComponentCard title="Section 2" id={data.core.id} commentsCount={componentCommentsCount(data.core.id)}>
        <SubComponentCard
          title="Prompt (TL)"
          id={data.core.id + "_tl_prompt"}
          commentsCount={componentCommentsCount(data.core.id + "_tl_prompt")}
        >
          <Paper
            elevation={0}
            square
            className="p-16"
          >
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    <Typography 
                      className={`${tl} m-0`}
                      dir={dir}
                      dangerouslySetInnerHTML={{ __html: data.core.prompt_tl }} 
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </SubComponentCard>

        <SubComponentCard
          title="Prompt (EN)"
          id={data.core.id + "_en_prompt"}
          commentsCount={componentCommentsCount(data.core.id + "_en_prompt")}
        >
          <Paper
            elevation={0}
            square
            className="p-16"
          >
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    <Typography 
                      className="text_14 m-0"
                      dangerouslySetInnerHTML={{ __html: data.core.prompt_en }} 
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </SubComponentCard>

        <SubComponentCard
          title="Schoolhouse Response"
          id={data.core.id + "_response"}
          commentsCount={componentCommentsCount(data.core.id + "_response")}
        >
          <Paper
            elevation={0}
            square
            className="p-16"
          >
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    <Typography 
                      className={`${tl} m-0`}
                      dir={dir}
                      dangerouslySetInnerHTML={{ __html: data.core.response }} 
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </SubComponentCard>

      </ComponentCard>

      {completionPages.length > 0 && (
        <ComponentCard title="Completion Events" id="completion_events" commentsCount={componentCommentsCount("completion_events")}>
          {completionPages.map((page, index) => (
            <SubComponentCard key={page.id} title={`${page.title} - ${page.label}:`} id={page.id + "cf"} commentsCount={componentCommentsCount(page.id + "cf")}>
              <Paper elevation={0} square className="p-16">
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Divider className='my-8' />
                  </Grid>
                  <Grid item xs={12} sm={4} lg={2}>
                    <Typography className="text-14 font-semibold m-0">
                      Feedback (TL):
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={8} lg={10}>
                    <Typography
                      className={`${tl} m-0 wysiwyg`}
                      dir={dir}
                      dangerouslySetInnerHTML={{ __html: page.content.core.text_tl }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} lg={2}>
                    <Typography className="text-14 font-semibold m-0">
                      Feedback (EN):
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={8} lg={10}>
                    <Typography
                      className="text-14 m-0 wysiwyg"
                      dangerouslySetInnerHTML={{ __html: page.content.core.text_en }}
                    />
                  </Grid>                
                </Grid>
              </Paper>
            </SubComponentCard>
          ))}
        </ComponentCard>
      )}
    </div>
  );
}
